module.exports = __webpack_public_path__ + "static/media/logo.2ef6f4a4.png";